import React, { useRef, useState } from "react";
import styles from "./styles.module.scss";
import SearchCasesNew from "components/SearchCasesNew";
import Input from "components/Input";
import { IData } from ".";
import SearchByNip from "components/SearchByNip";
import { IEntity } from "dto/IEntity";
import { useOnClickOutside } from "usehooks-ts";
import { useTranslation } from "react-i18next";

interface CompanyFormProps {
  data: IData;
  setData: (data: IData) => void;
  handleAdd: (
    type: string,
    regon?: string,
    address?: any,
    name?: string
  ) => void;
  fetchData: (index: number) => void;
  isPackages: boolean;
  entities: IEntity[];
}

const CompanyForm: React.FC<CompanyFormProps> = ({
  data,
  setData,
  handleAdd,
  fetchData,
  isPackages,
  entities,
}) => {
  const { t } = useTranslation();

  const handleCompanyData = (company: any) => {
    handleAdd(
      "all",
      company.Regon,
      {
        city: company.Place,
        street: company.Street,
        zipCode: company.ZipCode,
      },
      company.Name
    );
  };

  const [showPersons, setShowPersons] = useState(false);

  const dropdownRef = useRef(null);

  useOnClickOutside(dropdownRef, () => {
    setShowPersons(false);
  });

  return (
    <div className={styles.form}>
      <SearchByNip
        onDataChange={handleCompanyData}
        defaultValue={data.nip ?? ""}
        onChange={(t) => setData({ ...data, nip: t })}
      />
      <div ref={dropdownRef} className={styles.personWrapper}>
        <Input
          value={data.name.replaceAll("<", "").replaceAll(">", "")}
          onChange={(t) => setData({ ...data, name: t })}
          onRightText={t("common.fetchData")}
          onRightClick={
            isPackages ? () => setShowPersons(!showPersons) : undefined
          }
          label={t("common.name")}
        />
        {showPersons && (
          <div className={styles.dropdown}>
            <div className={styles.dropdownWrapper}>
              {entities.map((entity, index) => {
                return (
                  <div
                    key={index}
                    onClick={() => {
                      fetchData(index);
                      setShowPersons(false);
                    }}
                    className={styles.dropdownBox}
                  >
                    {entity.Name.length ? entity.Name : entity.Email}
                  </div>
                );
              })}
            </div>
          </div>
        )}
      </div>
      {data?.emails?.length > 0 && (
        <div className={styles.input}>
          <Input
            value={data.emails[0]}
            onChange={(t) => {
              const newEmails = [...data.emails];
              newEmails[0] = t;
              setData({ ...data, emails: newEmails });
            }}
            label={t("auth.email")}
            isEmail
          />
        </div>
      )}

      <div className={styles.input}>
        <Input
          isPhoneNumber
          value={data.phones[0]}
          onChange={(t) => {
            const newPhones = [...data.phones];
            newPhones[0] = t;
            setData({ ...data, phones: newPhones });
          }}
          label={t("forms.phoneNumber")}
        />
      </div>

      {data?.EAddresses?.length > 0 && (
        <div className={styles.input}>
          <Input
            value={data.EAddresses[0]}
            onChange={(t) => {
              const newAddresses = [...data.EAddresses];
              newAddresses[0] = t;
              setData({ ...data, EAddresses: newAddresses });
            }}
            label={t("forms.eDeliveryAddress")}
          />
        </div>
      )}
      <SearchCasesNew
        setAddNewEntity={() => {}}
        defaultValue={data.Case?.Id}
        onChoose={(cas) => setData({ ...data, Case: cas })}
      />
    </div>
  );
};

export default CompanyForm;
